// extracted by mini-css-extract-plugin
module.exports = {"body":"Welcome_body__3m_AX","title":"Welcome_title__CXtGh","brand":"Welcome_brand__1CBpn","description":"Welcome_description__2cQ_c","updates":"Welcome_updates__1ZlMT"};